
import React from 'react';
import { InfoTwoTone as InfoIcon } from '@mui/icons-material';
import { flowRight } from 'lodash';
import { VARIABLE_VALUE } from 'pages/CapTable/cap-table/utilities/variablePropertiesUtils';
import VariableValueViewerProps from './VariableValueViewer.props';
import { classes, StyledHtmlTooltip } from './VariableValueViewer.styles';
import withDialog from '../../../WithDialog';


const VariableValueViewer = ({ cell }: VariableValueViewerProps) => {
  const { value } = cell;
  return (
    <StyledHtmlTooltip title={cell.defaultTooltip ?? ''} placement="top" arrow>
      <span className="value-viewer">
        <InfoIcon className={classes.icon} />
        <span className="text-cell">{(value as string) === VARIABLE_VALUE ? VARIABLE_VALUE : (value as string)}</span>
      </span>
    </StyledHtmlTooltip>
  );
};
const enhancements = flowRight(withDialog);
export default enhancements(VariableValueViewer);
